import { render, staticRenderFns } from "./BuildingGateway.global.vue?vue&type=template&id=1b563e08&lang=pug&"
import script from "./BuildingGateway.global.vue?vue&type=script&lang=ts&"
export * from "./BuildingGateway.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports